/*
 * File: /src/store/modules/callResults.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import VoiceServices from 'src/services/voiceServices';

const state = {
  callResults: undefined,
};

const getters = {
  getCallResults: (state) => {
    return state.callResults;
  },
};
const actions = {
  async fetchCallResults({ commit, state, rootGetters }) {
    if (state.callResults == undefined) {
      const res = await VoiceServices.fetchCallResults();
      commit('setCallResults', res.data);
    }
  },
  unloadCallResults({ commit }) {
    commit('setCallResults', undefined);
  },
};
const mutations = {
  setCallResults(state, callResults) {
    state.callResults = callResults;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
